import Breadcrumbs from "components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap"
import Select from "react-select"
import { getCountryList } from "store/actions/countriesAction"
import { syncMenu } from "store/actions/posAction"
import { showAlert } from "store/reducers/alertReducer"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useNavigate } from "react-router-dom"
// import { getBrandList } from "store/actions/brandsAction"
import { getMenuByBrandandCountry } from "store/actions/menuSetupAction"
import { useBrandOptions } from "hooks"

const MenuSync = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Menu Sync ")

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [selectedBrand, setSelectedBrand] = useState(null)
  const [selectedMenu, setSelectedMenu] = useState(null)
  const { loading, isLoading } = useSelector(state => state.POS)
  const { countryList } = useSelector(state => state.Countries)
  // const { brandList } = useSelector(state => state.Brands)
  const { allowedBrands } = useBrandOptions()

  const { menusByCountryandBrands } = useSelector(state => state.MenuSetup)

  const brandOptions =
    allowedBrands.map(obj => ({
      value: obj._id,
      label: obj.brandName,
    })) || []

  const { userRole, accountType } = useSelector(state => state.Login)

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      30,
      "menu_sync_3",
      accountType
    )

    if (!isPermissionEdit) {
      navigate("/dashboard")
    }
  }, [userRole])

  useEffect(() => {
    // dispatch(getBrandList())
    const fetchCountryList = () => {
      dispatch(getCountryList())
    }
    fetchCountryList()
  }, [])

  useEffect(() => {
    if (selectedCountry && selectedBrand) {
      const payload = {
        countryCode: [selectedCountry?.value],
        brand: selectedBrand?.value,
      }
      setSelectedMenu(null)
      dispatch(getMenuByBrandandCountry(payload))
    }
  }, [selectedBrand, selectedCountry])

  const handleMenuSync = () => {
    const { value } = selectedCountry

    const payload = {
      countryCode: value,
      menuId: selectedMenu?.value,
    }
    dispatch(syncMenu(payload))
      .then(action => {
        const { statusCode, status, success, msg, message } = action?.payload
        if ((statusCode === 200 && status) || success) {
          dispatch(showAlert({ text: msg || message, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg || message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const menuOptions =
    menusByCountryandBrands?.map(obj => ({
      value: obj?.menuId,
      label: language === "sa" ? obj?.menuNameAr : obj?.menuNameEn,
    })) || []

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <CardBody className="mb-5">
                <CardTitle className="mb-2">{t("Menu Sync")}</CardTitle>
                <Row>
                  <Col md={6}>
                    <div className="form_field">
                      <Label htmlFor="">
                        <span className="text-danger">*</span>{" "}
                        {t("Select Country")}
                      </Label>
                    </div>
                    <Select
                      value={selectedCountry}
                      onChange={item => {
                        setSelectedCountry(item)
                      }}
                      options={countryList?.map(item => ({
                        label: language === "sa" ? item.nameAr : item.name,
                        value: item.countryCode,
                      }))}
                      className={`select2-selection`}
                      placeholder={t("Select Country")}
                    />
                  </Col>
                  <Col md={6}>
                    <div className="form_field">
                      <Label htmlFor="">
                        <span className="text-danger">*</span>{" "}
                        {t("Select Brand")}
                      </Label>
                    </div>
                    <Select
                      value={selectedBrand}
                      onChange={item => setSelectedBrand(item)}
                      options={brandOptions}
                      placeholder={t("Select Brand")}
                      className={`select2-selection`}
                    />
                  </Col>
                  <Col md={6}>
                    <div className="form_field">
                      <Label htmlFor="">
                        <span className="text-danger">*</span>{" "}
                        {t("Select Menu")}
                      </Label>
                    </div>
                    <Select
                      options={menuOptions}
                      onChange={item => setSelectedMenu(item)}
                      value={selectedMenu}
                      placeholder={t("Select Menu")}
                      className={`select2-selection`}
                    />
                  </Col>

                  <Col lg={6}>
                    <div className="d-flex align-items-end h-100">
                      <Button
                        color="primary"
                        disabled={!selectedMenu || isLoading}
                        onClick={handleMenuSync}
                      >
                        {t("Sync Menu")}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default MenuSync
